<template>
  <v-card>
    <v-card-title>
      What is this?
    </v-card-title>
    <v-card-text>
      <p class="mb-0">
        Email verification ensures you send to valid email addresses that will not result in a bounce. Some of the most common benefits of verification include:
      </p>
      <ul class="mb-2">
        <li>
          Increase inbox delivery and avoid spam boxes
        </li>
        <li>
          Adhere to bounce rate policies set forth by all major Email Service Providers (keep from getting banned)
        </li>
        <li>
          Maintain/achieve a higher sender reputation
        </li>
      </ul>
      <p>
        Verifying an email address with Mobile Locker will accurately determine whether or not an email account is active and receiving mail.
      </p>
      <p class="mb-0">
        Once enabled, you can upload a list of email addresses and accurately determine whether or not an email is active and able to receive mail.
      </p>
    </v-card-text>
    <v-card-actions v-if="team.email_verification_enabled === false || canVerifyEmails === false">
      <v-btn color="primary"
             @click.prevent="activateEmailVerification">
        Active Email Verification
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import emailVerificationService from '../../../services/emailVerificationService';
import {mapGetters} from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'canVerifyEmails',
      'team',
      'user',
    ])
  },
  methods: {
    async activateEmailVerification() {
      await emailVerificationService.activate();
      await this.$store.dispatch('initStore')
      this.$emit('updated');
    },
  }
}
</script>
